/**
 * Main JavaScript entry point
 * This file imports and initializes all site functionality
 */

// Import each script file
import './countdown.js';
import './fade-in.js';
import './cookie-banner.js';
import './nav.js';
import './accordion.js';
import './video-facade.js';

// Add any additional initialization code here
console.log('Bilger for Congress - Site loaded');
